/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Manufacturer } from './Manufacturer';
import {
    ManufacturerFromJSON,
    ManufacturerFromJSONTyped,
    ManufacturerToJSON,
} from './Manufacturer';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableManufacturers
 */
export interface PageableManufacturers {
    /**
     * 
     * @type {Array<Manufacturer>}
     * @memberof PageableManufacturers
     */
    result: Array<Manufacturer>;
    /**
     * 
     * @type {Page}
     * @memberof PageableManufacturers
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableManufacturers interface.
 */
export function instanceOfPageableManufacturers(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableManufacturersFromJSON(json: any): PageableManufacturers {
    return PageableManufacturersFromJSONTyped(json, false);
}

export function PageableManufacturersFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableManufacturers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(ManufacturerFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableManufacturersToJSON(value?: PageableManufacturers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(ManufacturerToJSON)),
        'page': PageToJSON(value.page),
    };
}

